import { SlotController } from "./slot.controller";

angular
    .module("thor.core.slot.component", [])
    .component("thorSlot", {
        bindings: {
            slots: "=",
            limit: "<?",
            type: "<",
            isDisabled: "<"
        },
        controller: SlotController,
        controllerAs: "slotCtrl",
        template: require("./slot.html")
    });
